/**
 * Find a summary by id, null if not found
 *
 * @param {number} id
 * @returns {?object}
 */
function findSummaryById(id) {
  return WP.summaryIdMap.find((summary) => summary.id === id) ?? null;
}

export default findSummaryById;
